import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "app-container"
}
const _hoisted_2 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportBanner = _resolveComponent("SupportBanner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Sidenav = _resolveComponent("Sidenav")!
  const _component_StepUpModal = _resolveComponent("StepUpModal")!
  const _component_TwoFactorPromptModal = _resolveComponent("TwoFactorPromptModal")!
  const _component_PermReviewModal = _resolveComponent("PermReviewModal")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, null, {
    default: _withCtx(() => [
      _createCommentVNode(" 지원 탭 배너: 모든 router-view 분기 위, 닫기 없음(계약 SUPPORT 5) "),
      (!_ctx.isSupportPage)
        ? (_openBlock(), _createBlock(_component_SupportBanner, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_ctx.shouldHideSidenav)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Sidenav, { class: "sidenav" }),
            _createElementVNode("main", _hoisted_2, [
              _createVNode(_component_router_view)
            ]),
            _createCommentVNode(" 2차 인증 step-up 창: API 가 MFA_REQUIRED·SEND_AUTH_REQUIRED 를 주면 뜬다(W6 B1) "),
            _createVNode(_component_StepUpModal),
            _createVNode(_component_TwoFactorPromptModal, {
              visible: _ctx.showTwoFactorPrompt,
              onGoSetup: _ctx.handleGoSetup,
              onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTwoFactorPrompt = false)),
              onSnooze: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTwoFactorPrompt = false))
            }, null, 8 /* PROPS */, ["visible", "onGoSetup"])
          ])),
      _createCommentVNode(" 직원 권한 정기 확인(6개월): 로그인 뒤 화면에서 탭·계정마다 한 번, 로그아웃하면 표시를 지움(T-CONTRACT-1031 §2) "),
      _createVNode(_component_PermReviewModal, {
        active: !_ctx.shouldHideSidenav && !_ctx.isSupportPage
      }, null, 8 /* PROPS */, ["active"])
    ]),
    _: 1 /* STABLE */
  }))
}